import script from "./StudentEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudentEdit.vue?vue&type=script&lang=ts&setup=true"

import "./StudentEdit.vue?vue&type=style&index=0&id=fa4b04b0&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa4b04b0"]])

export default __exports__